
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metal-resources/tutorials",
      function () {
        return require("private-next-pages/metal-resources/tutorials/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metal-resources/tutorials"])
      });
    }
  